import { IUser } from '@epicuro-next/data/users';

export interface UserEntity {
  userExternalId: string;
  user?: IUser;
  loading?: boolean;
}

export enum LoadUserStrategy {
  Lazy = 'lazy',
  Eager = 'eager',
}
